import * as actionTypes from "../actions/actionTypes";

const initialState = {
  Empleado: [],
  Servicios: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_EMPLEADO: {
      return {
        ...state,
        Empleado: action.Empleado,
      };
    }
    case actionTypes.SET_ADMIN_APPS: {
      return {
        ...state,
        Servicios: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
